<template>
  <div class="selection-step">
    <SimonModal
      :is-visible="showSimTypeInfoModal"
      @hide="showSimTypeInfoModal = false"
      id="sim-type-info-modal"
      size="large"
    >
      <template v-slot:modalTitle>
        <h3 class="text-center"><slot name="titleSimTypeInfoModal"></slot></h3>
      </template>
      <div class="sim-modal-body">
        <b-card no-body>
          <b-tabs card pills align="center">
            <b-tab :title="this.$slots.tabSimTypeInfoModalSim[0].text" :active="!isESimSelected">
              <b-card-text><slot name="txtSimTypeInfoModalSim"></slot></b-card-text>
            </b-tab>
            <b-tab :title="this.$slots.tabSimTypeInfoModalESim[0].text" :active="isESimSelected">
              <b-card-text><slot name="txtSimTypeInfoModalESim"></slot></b-card-text>
            </b-tab>
          </b-tabs>
        </b-card>
      </div>
    </SimonModal>
    <SimonModal
      :is-visible="showClassicSimTypeInfoModal"
      @hide="showClassicSimTypeInfoModal = false"
      id="classic-sim-type-info-modal"
    >
      <template v-slot:modalTitle>
        <h3><slot name="titleClassicInfoModal"></slot></h3>
      </template>
      <div class="sim-modal-body">
      <b-card no-body>
        <b-tabs card pills align="center">
          <b-tab :title="this.$slots.tabClassicInfoModalSim[0].text" :active="isActivateByCustomer">
            <b-card-text><slot name="txtClassicInfoModalSim"></slot></b-card-text>
          </b-tab>
          <b-tab :title="this.$slots.tabClassicInfoModalESim[0].text" :active="!isActivateByCustomer">
            <b-card-text><slot name="txtClassicInfoModalESim"></slot></b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>
      </div>
    </SimonModal>

    <SimonModal
      :is-visible="showESimCheckInfoModal"
      @hide="showESimCheckInfoModal = false"
      id="esim-check-info-modal"
      size="large"
      custom-modal-class="esim-check-info-modal"
    >
      <b-form
        :id="'form' + _uid"
        :novalidate="true"
        class="device-check-modal-form"
        ref="form">
        <ESimDevicecheck :available-device-types="availableDeviceTypes">
          <template v-for="slot in possibleChildSlotsFor('DeviceCheck')" v-slot:[`${slot.child}`]>
            <slot :name="`${slot.parent}`"></slot>
          </template>
        </ESimDevicecheck>
      </b-form>
    </SimonModal>

    <div class="content-card">
      <slot name="titleHeadline"></slot>
      <slot name="txtHeadline"></slot>
    </div>
    <b-form
      :id="'form' + _uid"
      :novalidate="true"
      class="substitute-selection-step"
      ref="form">
      <div class="content-card">
        <div class="content-card-title"><slot name="titleCardESim"></slot>
        </div>
        <div class="selection-cards">
          <b-form-group class="radio-group group-selection">
            <label class="d-inline-block has-icon">
              <span><slot name="txtCardESim"></slot></span>
              <i @click="showSimInfoModal()" class="info-link-icon"></i>
            </label>
            <b-form-radio-group v-model="selectedSimType" name="simSelection" @change="storeSelectedSimType">
              <b-form-radio id="selectSimCard" value="SIM_CARD"><slot name="radioTextSim"></slot></b-form-radio>
              <b-form-radio id="selectESim" value="E_SIM"><slot name="radioTextESim"></slot></b-form-radio>
              <div class="info-device-box">
                <a href="javascript:openDeviceCheck();"
                  @click.prevent="showESimCheckInfoModal = !showESimCheckInfoModal">
                  <slot name="txtESimInfoBoxLink">sdffs</slot>
                </a>
             </div>
            </b-form-radio-group>
          </b-form-group>
        </div>
      </div>
      <div v-if="selectedSimType === 'SIM_CARD'" class="content-card">
        <slot name="titleSimWrapper"></slot>
        <div class="selection-cards">
          <b-form-group class="radio-group group-selection">
            <label class="d-inline-block has-icon">
              <span><slot name="txtCardSim"></slot></span>
              <i @click="showClassicSimInfoModal()" class="info-link-icon"></i>
            </label>
            <b-form-radio-group v-model="selectedActivationType" name="activateSelection" @change="storeSelectedActivationType">
              <b-form-radio id="selfActivate" value="BY_CUSTOMER"><slot name="radioTxtByCustomer"></slot></b-form-radio>
              <b-form-radio id="preActivate" value="PREACTIVATED"><slot name="radioTxtPreactivated"></slot></b-form-radio>
            </b-form-radio-group>
          </b-form-group>
        </div>
      </div>
    </b-form>
    <Stepper
      @next="nextStep()"
      :show-prev="true"
      @prev="back()"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>

<script>

import { mapGetters, mapMutations } from 'vuex'

import Stepper from '@/components/generic/Stepper.vue'
import ESimDevicecheck from '@/components/process/generic/SubstituteSimCard/ESimDevicecheck.vue'
import SimonModal from '@/components/modal/SimonModal.vue'

export const stepName = 'selection'

export default {
  name: 'SubstituteESimSelection',
  data () {
    return {
      showSimTypeInfoModal: false,
      showClassicSimTypeInfoModal: false,
      showESimCheckInfoModal: false,
      selectedSimType: '',
      selectedActivationType: ''
    }
  },
  computed: {
    ...mapGetters('substituteSimCard', [
      'getStatusSimType', 'getActivationType'
    ]),
    isActiveESim () {
      return this.activeSimType === 'E_SIM'
    },
    isActivateByCustomer () {
      let bool = ''
      if (this.selectedActivationType === 'PREACTIVATED') {
        bool = false
      } else if (this.selectedActivationType === 'BY_CUSTOMER') {
        bool = true
      }
      return bool
    },
    isESimSelected () {
      return this.selectedSimType === 'E_SIM'
    }
  },
  methods: {
    ...mapMutations('substituteSimCard', [
      'changeStep',
      'setStatusSimType',
      'setSelectedActivationType',
      'setSelectionData',
      'setStep',
      'setActivationService'
    ]),
    showSimInfoModal () {
      this.showSimTypeInfoModal = true
    },
    showClassicSimInfoModal () {
      this.showClassicSimTypeInfoModal = true
    },
    storeSelectedSimType () {
      this.setStatusSimType(this.selectedSimType)
      if (this.isESimSelected) {
        this.selectedActivationType = 'PREACTIVATED'
        this.storeSelectedActivationType()
      }
    },
    storeSelectedActivationType () {
      this.setSelectedActivationType(this.selectedActivationType)
      this.setActivationService(this.selectedActivationType === 'PREACTIVATED')
    },
    nextStep () {
      this.loading = true
      this.setSelectionData({
        simType: this.selectedSimType,
        activation: this.selectedActivationType
      })
      this.setActivationService(!this.isActivateByCustomer)
      this.changeStep('summary')
    },
    back () {
      window.location.href = this.backLink
    },
    triggerTracking: function () {
      let propositions = ''
      if (typeof window.trackingNS?.track?.getSimSwapPropositions === 'function') {
        propositions = window.trackingNS.track.getSimSwapPropositions(this.getSimCardOption, null)
      }
      const data = {
        page_levels: [
          'mein-simon',
          'meine-sim',
          'sim replacement',
          'sim type selection'
        ],
        login_status: 'not logged in', // check/set in tracking
        page_type: 'checkout',
        platform_type: 'browser view',
        form: {
          name: 'sim replacement',
          step_name: 'sim type selection',
          step: '1',
          type: 'order funnel'
        },
        propositions: propositions
      }
      if (typeof window.trackingNS?.track?.tracking === 'function') {
        window.trackingNS.track.tracking('pageview', data)
      }
    }
  },
  created () {
    this.setStep('selection')
  },
  mounted () {
    this.selectedActivationType = this.getActivationType
    this.selectedSimType = this.getStatusSimType
    this.triggerTracking()
  },
  components: {
    SimonModal,
    Stepper,
    ESimDevicecheck
  },
  mixins: [

  ],
  props: {
    backLink: {
      type: String,
      required: true
    },
    activeSimType: {
      type: String,
      default: null
    },
    availableDeviceTypes: {
      type: String,
      default: ''
    }
  }
}
</script>
